export function getJaugeValue(lang) {
  let url = window.CONFIG.jauge_api + "?country=" + lang

  return fetch(url)
  .then(data => data.json())

}



export function getTwitterLink(text) {
  return "https://twitter.com/intent/tweet?text=" + encodeURIComponent(text)
}

export function getFacebookLink(text) {
  return "http://www.facebook.com/sharer.php?u=http://www.brain-thegame.com"
}

export function getLinkedinLink(text) {
  return `https://www.linkedin.com/sharing/share-offsite?url=http://www.brain-thegame.com`
}